<template>
  <div class="list-evaluate">
    <back-nav :to="'/lists/'+listId" :list-title="listTitle"></back-nav>
    <page-title v-bind:title="'Rate ideas'"></page-title>
    <ideas-to-evaluate :listIds="[listId]"></ideas-to-evaluate>
  </div>
</template>

<script>
import bus from '../bus';

import IdeasToEvaluate from "../components/IdeasToEvaluate";
import PageTitle from "../components/PageTitle.vue";
import BackNav from "../components/lists/BackNav";

export default {
  components: {
    IdeasToEvaluate,    
    PageTitle,
    BackNav
  },
  data() {
    return {};
  },
  computed: {
    listId() {
      return this.$route.params.id;
    },
    listTitle() {
      return this.listId && this.$store.getters.getListById(this.listId).title;
    },
  },
  beforeMount() {
    bus.$emit("show-loader", "");
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.list-evaluate {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: theme.$light-background;
  padding: theme.$page-padding-top theme.$page-padding-X;
}

.back-nav {
  margin-left: 30px;
  margin-top: 30px;
}

.icon-arrow-back::before {
  font-size: 24px;
  vertical-align: sub;
}

.back-text {
  font-size: 14px;
  margin-left: 5px;
}
</style>